<template>
  <svg
    width="30"
    height="40"
    viewBox="0 0 30 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.8586 1.58887V39.2518C23.8586 39.2518 16.7755 36.0033 1.50998 35.234V4.34886C1.50998 4.34886 13.3071 5.35028 23.8586 1.58887Z"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M19.8163 21.7633C20.7875 21.7633 21.5749 20.9759 21.5749 20.0047C21.5749 19.0334 20.7875 18.2461 19.8163 18.2461C18.8451 18.2461 18.0577 19.0334 18.0577 20.0047C18.0577 20.9759 18.8451 21.7633 19.8163 21.7633Z"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M23.7609 4.25098H29V36.5771H23.8586"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
  </svg>
</template>
